module.exports = __webpack_public_path__ + "m-search-1-3fc67de6.png";